(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 28575:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(71370);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function AlertMessage(param) {
    var type = param.type, text = param.text;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true), visible = ref[0], setVisible = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var timer = setTimeout(function() {
            setVisible(false);
        }, 5000);
        return function() {
            return clearTimeout(timer);
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: visible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "alert-message ".concat(type),
            children: text
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AlertMessage);


/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32909);


function FormsLogo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "d-flex justify-content-center margin_bottom-24",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_1__/* .LogoBig */ .$T, {})
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormsLogo);


/***/ }),

/***/ 76931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36968);


function Loader() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "#ffffffab",
            zIndex: 9998
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                position: "fixed",
                top: "45%",
                left: "50%",
                textAlign: "center",
                zIndex: 9999
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                animation: "border",
                role: "status",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "visually-hidden",
                    children: "Loading..."
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Loader);


/***/ }),

/***/ 57282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B1": function() { return /* binding */ EMAIL_VALIDATOR; },
/* harmony export */   "oq": function() { return /* binding */ DOCUMENT_EXTENSIONS; }
/* harmony export */ });
/* unused harmony export IMAGE_EXTENSIONS */
var EMAIL_VALIDATOR = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
var DOCUMENT_EXTENSIONS = ".pdf,.csv,.doc,.docx,.xlsx,.txt,.jpg,.jpeg,.png,.heic";
var IMAGE_EXTENSIONS = ".jpg,.jpeg,.png";


/***/ }),

/***/ 53567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ authGuard; },
  "k": function() { return /* reexport */ unAuthGuard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/helpers/hoc/unAuthGuard.tsx


function withOutAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var unAuthGuard = (withOutAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/authGuard.tsx


function withAuth(WrapperComponent) {
    return function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperComponent, (0,_object_spread/* default */.Z)({}, props));
    };
}
/* harmony default export */ var authGuard = (withAuth);

;// CONCATENATED MODULE: ./src/helpers/hoc/index.ts




/***/ }),

/***/ 2324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useFormBackground; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useFormBackground() {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.body.classList.add("form_background");
        return function() {
            document.body.classList.remove("form_background");
        };
    }, []);
}


/***/ }),

/***/ 71370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_FormsLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5283);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4266);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(74119);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(35005);
/* harmony import */ var src_components_AlertMessage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10067);
/* harmony import */ var src_config_validators__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57282);
/* harmony import */ var src_requests_auth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19795);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var src_components_Loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76931);
/* harmony import */ var src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2324);
/* harmony import */ var src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53567);
/* harmony import */ var src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(49499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_11__);


















function Signup() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_11__.useRouter)(), _query = ref.query, invitation_key = _query.invitation_key, is_topp = _query.is_topp;
    (0,src_helpers_hooks_auth__WEBPACK_IMPORTED_MODULE_8__/* .useFormBackground */ .b)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        email: "",
        password: "",
        name: "",
        companyName: "",
        disabled: false
    }), info = ref1[0], setInfo = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), alert = ref2[0], setAlert = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), steps = ref3[0], setSteps = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), working = ref4[0], setWorking = ref4[1];
    var checkValidation = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var data, ref, ref1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_5__/* .invitationValidationCheck */ .aq)(invitation_key);
                    case 3:
                        data = _ctx.sent.data;
                        setInfo((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, info), {
                            disabled: true,
                            email: data.data.email,
                            companyName: data.data.organization
                        }));
                        _ctx.next = 11;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                        ;
                        setAlert({
                            text: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message,
                            type: "error"
                        });
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function checkValidation() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!invitation_key) return;
        checkValidation();
    }, [
        invitation_key
    ]);
    var handleNext = function(nextStep) {
        var email = info.email, password = info.password, name = info.name;
        if (steps <= 2) {
            if (steps === 0) {
                if (email.length > 0 && src_config_validators__WEBPACK_IMPORTED_MODULE_15__/* .EMAIL_VALIDATOR.test */ .B1.test(email) && password.length > 0) {
                    setSteps(nextStep);
                } else {
                    setAlert({
                        text: "Email or Password is not valid",
                        type: "error"
                    });
                }
            } else if (steps === 1) {
                if (name.length > 5) {
                    setSteps(nextStep);
                } else {
                    setAlert({
                        text: "Name is not correctly formatted",
                        type: "error"
                    });
                }
            }
        } else setSteps(nextStep);
    };
    var handleInput = function(event) {
        var _target = event.target, name = _target.name, value = _target.value;
        setInfo((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, info), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, name, value)));
    };
    var handleSubmit = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var email, password, name, organization_name, creds, ref, ref1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = info.email, password = info.password, name = info.name, organization_name = info.companyName;
                        creds = {
                            email: email,
                            password: password,
                            name: name,
                            organization_name: organization_name
                        };
                        //if invite key hide topp radio buttons
                        if (invitation_key) {
                            creds.invitation_key = invitation_key;
                            creds.is_topp = is_topp ? true : false;
                        }
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_5__/* .signupUserWithCreds */ .IW)(creds);
                    case 6:
                        setWorking(true);
                        setSteps(2);
                        _ctx.next = 14;
                        break;
                    case 10:
                        _ctx.prev = 10;
                        _ctx.t0 = _ctx["catch"](3);
                        ;
                        setAlert({
                            text: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || _ctx.t0.message || "Something went wrong",
                            type: "error"
                        });
                    case 14:
                        _ctx.prev = 14;
                        setWorking(false);
                        return _ctx.finish(14);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    10,
                    14,
                    17
                ]
            ]);
        }));
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleResend = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var email, data, ref, ref1;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        email = info.email;
                        _ctx.prev = 1;
                        setWorking(true);
                        _ctx.next = 5;
                        return (0,src_requests_auth__WEBPACK_IMPORTED_MODULE_5__/* .resendActivationEmail */ .dS)(email);
                    case 5:
                        data = _ctx.sent.data;
                        setAlert({
                            text: (data === null || data === void 0 ? void 0 : data.message) || "Mail sent",
                            type: "success"
                        });
                        _ctx.next = 13;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        ;
                        setAlert({
                            text: (_ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message) || "Something went wrong",
                            type: "error"
                        });
                    case 13:
                        _ctx.prev = 13;
                        setWorking(false);
                        return _ctx.finish(13);
                    case 16:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9,
                    13,
                    16
                ]
            ]);
        }));
        return function handleResend() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: "CreateAccountForm",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Metadata__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Quick Organic Signup"
            }),
            working && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Loader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            alert && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_AlertMessage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, alert)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    className: "form_login color_bg-white color_border-gray--08",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "d-flex justify-content-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_FormsLogo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                        }),
                        steps === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    controlId: "floatingInput",
                                    label: "Email Address",
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Control */ .Z.Control, {
                                        type: "email",
                                        placeholder: "Email Address",
                                        name: "email",
                                        className: "form_input",
                                        value: info.email,
                                        onChange: handleInput,
                                        disabled: info.disabled
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    controlId: "floatingPassword",
                                    label: "Password",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Control */ .Z.Control, {
                                        type: "password",
                                        placeholder: "Password",
                                        name: "password",
                                        className: "form_input",
                                        value: info.password,
                                        onChange: handleInput
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    variant: "primary",
                                    type: "button",
                                    className: "form_btn fw-400 w-100",
                                    name: "step1",
                                    onClick: function() {
                                        return handleNext(1);
                                    },
                                    children: "Create Account"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                    className: "fw-400 color_text-gray--01 text-center",
                                    style: {
                                        marginTop: "1em"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            children: "Already have an account?"
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            href: "/login",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                                className: "form_btn-no-outline color_text-primary",
                                                children: "Login"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : steps === 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "signup_topp-container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "fw-400 color_text-gray--01 text-center",
                                    style: {
                                        marginTop: "0em",
                                        marginBottom: "1em"
                                    },
                                    children: "Tell us about your operation"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    controlId: "floatingInput",
                                    label: "Your Name",
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Control */ .Z.Control, {
                                        type: "text",
                                        placeholder: "Your Name",
                                        name: "name",
                                        value: info.name,
                                        className: "form_input",
                                        onChange: handleInput
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    controlId: "floatingPassword",
                                    label: "Company Name",
                                    className: "mb-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_17__/* ["default"].Control */ .Z.Control, {
                                        type: "text",
                                        placeholder: "Company Name",
                                        name: "companyName",
                                        value: info.companyName,
                                        className: "form_input",
                                        onChange: handleInput,
                                        disabled: info.disabled
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    variant: "primary",
                                    type: "button",
                                    className: "form_btn w-100",
                                    name: "step2",
                                    onClick: handleSubmit,
                                    disabled: !info.name || !info.companyName ? true : false,
                                    children: [
                                        " ",
                                        "Create Account",
                                        " "
                                    ]
                                })
                            ]
                        }) : steps === 2 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    className: "fw-400 color_text-gray--01 text-center",
                                    style: {
                                        marginTop: "0em",
                                        marginBottom: "1em"
                                    },
                                    children: "Verify your email"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                                    children: [
                                        "Click on the verification button in the email we sent to ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "fw-400 color_text-gray--01",
                                            children: info.email
                                        }),
                                        ", this helps keep your account secure."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                    children: "No email in your inbox or spam folder? Let's resend it."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    variant: "primary",
                                    type: "button",
                                    className: "form_btn w-100",
                                    name: "step3",
                                    onClick: handleResend,
                                    children: "Resend Email"
                                })
                            ]
                        }) : null
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = ((0,src_helpers_hoc__WEBPACK_IMPORTED_MODULE_9__/* .withOutAuth */ .k)(Signup));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5231,8759,5799,9774,2888,179], function() { return __webpack_exec__(28575); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);